// frontend/src/api/largePhoto.ts
/**
 * A photo's large variant (or a pending inbox photo's master), for the photo
 * viewer zoomed past 2x: docs/plans/2026-10-30-photo-lightbox-large.md.
 * Tank shots, timeline entries and the photo inbox each have a `/large` route.
 */

import { apiClient } from './client';
import type { LargePhoto } from '@/types/tankPhotos';

/** GET a `/large` route: the signed URL and size, or null when there's no larger photo (404). */
export async function getLargePhoto(endpoint: string): Promise<LargePhoto | null> {
  const response = await apiClient(endpoint, { method: 'GET' });
  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return response.json() as Promise<LargePhoto>;
}
